import { ValidationResult } from './validation-result.model';

export abstract class BaseModel {
  id: any;
  abstract validate(errorPrefix?: string): ValidationResult;
}
